import { hasErrorRule, hasGetErrorRule, maxCharsMultiLineRule } from '../../../../Validation/rules';
export const onTextInputMultilineSet = [hasErrorRule, hasGetErrorRule, maxCharsMultiLineRule];